import React from 'react';
import { motion } from 'framer-motion';
const CART_LINK = 'https://creaycrecepro.shop/checkouts/cn/hWNAWLippdzlLj2KbA0phaJ0/es-ar?_r=AQABXe45mcGQp256mwxnogXyZaN3X8TPMhy8oauCA9MChHo&preview_theme_id=193700921425';
export function StickyAlertBar() {
  return <motion.a href={CART_LINK} className="fixed top-0 left-0 right-0 bg-alert text-white py-3 px-4 text-center z-50 shadow-lg block cursor-pointer hover:bg-red-700 transition-colors" initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-194">
      <motion.p className="text-sm md:text-base font-semibold" animate={{
      opacity: [1, 0.8, 1]
    }} transition={{
      duration: 2,
      repeat: Infinity
    }} data-id="element-195">
        🔥 HOY SOLAMENTE: 50% OFF + BONOS DIGITALES GRATIS + ACCESO INMEDIATO
      </motion.p>
    </motion.a>;
}